<template>
  <v-card class="mx-auto">
    <v-img
      src="@/assets/images/1799_share.png"
      height="350"
    ></v-img>

    <v-card-title class="justify-center">
      感謝您用心填寫問卷
    </v-card-title>

    <v-card-subtitle>
      1799 全體感謝您！
    </v-card-subtitle>

    <v-card-actions>
      <v-btn color="blue"
             dark
             href="mailto:service@1799.travel">
        聯絡我們
      </v-btn>
      <v-btn color="green"
             dark
             href="/">
        再填寫一次問卷
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        icon
        @click="show = !show"
      >
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>

        <v-card-text>
          {{ text }}
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  name: 'ThanksStep',
  data () {
    return {
      show: false,
      text: '想要更了解我們嗎？\n我們是 1799 一起走走，' +
        '面對突如其來的出團需求，協助領隊、導遊進行接團媒合，透過平台機制，' +
        '充分揭露出團訊息進而接團。1799 一起走走，意味著此刻旅行社、領隊、導遊等，' +
        '肩併肩帶給旅客全心的旅途。'
    }
  }
}
</script>

<style scoped>

</style>
